// parse date incoming from date input,
// comes in format YYYY-MM-DD
export function parseDate(str){
    const parts = str.split('-');
    return {
        year: parts[0],
        month: parts[1],
        day: parts[2],
    }
}
// Convert object into combined date string for date input
export function stringifyDate({month, day, year}){
    return `${padNumber(year, 4)}-${padNumber(month, 2)}-${padNumber(day, 2)}`;
}


// helper function to coerce input date into correct format
function padNumber(num, len){
    let int = parseInt(num);
    if(isNaN(int)) int = 0;
    return (int + '').padStart(len, '0');
}